// src/store/slices/telecallerSessionSlice.ts
import { createSlice } from "@reduxjs/toolkit";

interface SessionState {
  active: boolean;
}
const initialState: SessionState = { active: false };

const telecallerSession = createSlice({
  name: "telecallerSession",
  initialState,
  reducers: {
    startSession(state) {
      state.active = true;
    },
    stopSession(state) {
      state.active = false;
    },
  },
});

export const { startSession, stopSession } = telecallerSession.actions;
export default telecallerSession.reducer;
